module.exports = __webpack_public_path__ + "img/15_bohle.100d2240.png";